export default __webpack_public_path__ + "static/media/bet4.5633d7ac.png";